import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useConfigurations } from '@/stores/configurations'


export function useChatAttendance() {

    return defineStore('attendances', {
        state: () => ({
            progress: [],
            waiting: [],
            automation: [],
            closed: [],
            audit: {
                progress: [],
                waiting: [],
            },
            counters: {
                audit: {
                    progress: 0,
                    waiting: 0,
                    automation: 0
                }
            },
            filterAttendances: '',
            filteredChannels: [],
            filteredDepartments: [],
            /** 'all' | 'today' | 'yesterday' | 'unread' | 'last_from_client' — filtro rápido da lista lateral */
            listQuickFilter: 'all',
            showFilters: false,
            lastAttendance: {
                progress: null,
                waiting: null,
                automation: null,
            },
            modalAttendance: null,
            savedAttendance: null,
            ascSort: false,
            attendanceSortBy: 'last_message',
            savedAttendances: [],
            newAttendance: {
                clients: [],
                selectedChannel: null,
                saveChannel: false,
            },
            viewMode: 'Colunas',
            sortField: 'progress',
            automationLoader: false,
            isTyping: null,
            pagination: null,
        }),

        getters: {
            attendancesRoute() {
                const route = this.$router.currentRoute.value

                if (route?.name) {
                    if (route.name.includes('waiting')) return this.waiting
                    if (route.name.includes('automation')) return this.automation

                }

                return this.progress
            },

            currentAttendance: (state) => {
                const route = state.$router.currentRoute.value

                const attendancesRoute = computed(() => state.attendancesRoute)
                const routeId = route.params?.id || 0

                let currentAttendance
                if (state.modalAttendance) {

                    currentAttendance = state.attendancesInDashboard[state.modalAttendance.chat_step.replace('active','progress')]
                    .find((attendance) => attendance.id === parseInt(state.modalAttendance.id))
                } else {
 
                     /* currentAttendance = state.savedAttendance ? state.attendancesInDashboard[state.savedAttendance?.chat_step.replace('active','progress')]
                    .find((attendance) => attendance.id === parseInt(state.savedAttendance?.id)) :  attendancesRoute.value.find((attendance) => attendance.id === parseInt(routeId))
                    */

                    currentAttendance = attendancesRoute.value.find((attendance) => attendance.id === parseInt(routeId))

                }
                // Saves the accessed id in staten, for later return
                if (currentAttendance) state.lastAttendance[currentAttendance.chat_step] = currentAttendance.id

                return currentAttendance
            },

            filterAttendancesRoute: (state) => {

                const storeConfig = useConfigurations()

                let sortField = storeConfig.business?.settings?.chat_attendance_sort_by || 'last_message'

                     
                const savedAttendances = state.savedAttendances.map(({ id }) => id)
                const attendancesRoute = computed(() => state.attendancesRoute.filter(attendance => {
                    return !savedAttendances.includes(attendance.id) ? attendance : ''
                }))
                const filterTo = state.filterAttendances.toLowerCase()
                const filteredChannels = state.filteredChannels.map(({ id }) => id)
                const filteredDepartments = state.filteredDepartments.map(({ id }) => id)
           
                return attendancesRoute.value.filter((attendance) => {

                    if(!attendance.client) {
                        console.log('not found client in attendance', attendance)
                        return false
                    }
                    const clientName = (attendance.client.name || '').toLowerCase()
                    const clientUser = (attendance.client?.user || '').toLowerCase()
                    const rawContent = attendance.last_message?.content
                    const contentText = typeof rawContent === 'string'
                        ? rawContent
                        : (rawContent?.content || rawContent?.title || rawContent?.caption || '')
                    const lastMessage = String(contentText).toLowerCase()
                    return clientName.includes(filterTo) || clientUser.includes(filterTo) || lastMessage.includes(filterTo)
                }).filter(attendance => { return !filteredChannels.length ? attendance :  filteredChannels.includes(attendance.channel_id) })
                        .filter(attendance => { return !filteredDepartments.length ? attendance :  filteredDepartments.includes(attendance.departament_id) })
                        .filter((attendance) => {
                            const quick = state.listQuickFilter
                            if (quick === 'all') return true

                            if (quick === 'unread') {
                                const routeName = String(state.$router.currentRoute.value?.name ?? '')
                                if (!routeName.includes('chat.attendances.progress')) {
                                    return true
                                }

                                const unread = Number(attendance.unread_messages ?? attendance.unread_message ?? 0)
                                return unread > 0
                            }
                            if (quick === 'last_from_client') {
                                const routeName = String(state.$router.currentRoute.value?.name ?? '')
                                if (!routeName.includes('chat.attendances.progress')) {
                                    return true
                                }

                                const direction = String(attendance.last_message?.direction ?? '').toLowerCase()
                                if (direction) {
                                    return direction === 'received'
                                }

                                const ack = attendance.last_message?.ack
                                if (ack !== undefined && ack !== null && ack !== '') {
                                    return Number(ack) === 0
                                }

                                return String(attendance.last_interaction ?? '').toLowerCase() === 'client'
                            }

                            const ts = attendance.last_message?.timestamp
                            let activityMs = null
                            if (ts != null && ts !== '') {
                                const n = Number(ts)
                                activityMs = n < 1e12 ? n * 1000 : n
                            } else if (attendance.created_at) {
                                activityMs = new Date(String(attendance.created_at).replace(' ', 'T')).getTime()
                            }
                            if (activityMs == null || Number.isNaN(activityMs)) return false

                            const now = new Date()
                            const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
                            const tomorrowStart = todayStart + 86400000
                            const yesterdayStart = todayStart - 86400000

                            if (quick === 'today') {
                                return activityMs >= todayStart && activityMs < tomorrowStart
                            }
                            if (quick === 'yesterday') {
                                return activityMs >= yesterdayStart && activityMs < todayStart
                            }

                            return true
                        })
                            .sort((objA, objB) => {

 
    const isWaiting = objA.chat_step === 'waiting'; 

  
    const isAsc = state.ascSort;

  
  
    if (isWaiting) {
       
        let valA, valB;

        // Verifica qual campo usar para ordenar
        if (sortField === 'last_message') {

            
            valA = Number(objA.last_message?.timestamp || 0);
            valB = Number(objB.last_message?.timestamp || 0);
        } else {

          
            // Lógica do 'latest_transfed_at' com tratamento de data
            valA = objA.latest_transfed_at ? new Date(objA.latest_transfed_at.replace(' ', 'T')).getTime() : 0;
            valB = objB.latest_transfed_at ? new Date(objB.latest_transfed_at.replace(' ', 'T')).getTime() : 0;
        }

    
        return isAsc ? valA - valB : valB - valA;
    } 
    
    // 4. Lógica padrão (else) para quando NÃO é 'waiting'
    else {
        const valA = Number(objA.last_message?.timestamp || 0);
        const valB = Number(objB.last_message?.timestamp || 0);
        
        return isAsc ? valA - valB : valB - valA;
    }
                                
                                
                            }
                            
                            )
            },

            /**
             * @returns {{automation: ([{}]), waiting: ([{}]), progress: ([{}])}}
             */
            attendancesInDashboard: (state) => {
                if (
                    state.audit.progress.length === 0 &&
                    state.audit.waiting.length === 0
                ) {
                    return {
                        progress: state.progress,
                        waiting: state.waiting,
                        automation: state.automation,
                    }
                }

                /** List ID's to remove duplicates */
                const progressIds = state.progress.map((item) => item.id)
                let progress = [
                    ...state.progress,
                    ...state.audit.progress.filter((item) => !progressIds.includes(item.id)),
                ]

                /** List ID's to remove duplicates */
                const waitingIds = state.waiting.map((item) => item.id)
                let waiting = [
                    ...state.waiting,
                    ...state.audit.waiting.filter((item) => !waitingIds.includes(item.id)),
                ]

                return {
                    progress,
                    waiting,
                    automation: state.automation,
                }
            },

            /**
             * TODO: Refactor this function, using USER information
             * @param state
             * @returns {boolean}
             */
            auditUser: (state) => {
                return !!state.audit.progress || !!state.audit.waiting
            },
        },

        actions: {
            /**
             * @param {String} step
             * @param {String} orderBy = 'asc' | 'desc'
             */
            orderBy(step, orderBy) {
                const attendances = this[step]
                if (!attendances) return

                const order = orderBy === 'asc' ? 1 : -1
                attendances.sort((a, b) => {
                    const ta = Number(a.last_message?.timestamp || 0)
                    const tb = Number(b.last_message?.timestamp || 0)
                    if (ta > tb) return order
                    if (ta < tb) return -order
                    return 0
                })
            },

            /** @param {int} id */
            setCurrentAttendance(id) {
                this.attendanceActive = this.attendancesRoute.find((attendance) => attendance.id === id)
                //console.log(this.attendanceActive)
            },

            acceptSteps(isAudit = false) {
                if (isAudit) {
                    return ['progress', 'waiting']
                }

                return ['progress', 'waiting', 'automation']
            },

            /**
             *
             * @param {Number} id
             * @param {String[]} steps
             * @param {Boolean} returnOnlyPath
             * @returns {{}|null}
             */
            getAttendance(id, steps, returnOnlyPath = false) {
                let attendance, attendancePath = null
                const acceptedSteps = this.acceptSteps()
                if (!steps.every(step => acceptedSteps.includes(step))) {
                    console.error('[chat] getAttendance: steps is not valid', steps)
                    return null
                }

                steps.forEach(step => {
                    const attendanceIndex = this[step].find(item => item.id === id)
                    if (attendanceIndex !== undefined && attendanceIndex !== -1) {
                        attendancePath = this[step]
                        attendance = attendanceIndex
                    }
                })

                if (attendance) {
                    if (returnOnlyPath) return attendancePath

                    return attendance
                }

                if (!this.auditUser) {
                    return null
                }

                const auditSteps = this.acceptSteps(true)
                auditSteps.forEach(step => {
                    const auditIndex = this.audit[step].find(item => item.id === id)
                    if (auditIndex !== undefined && auditIndex !== -1) {
                        attendancePath = this.audit[step]
                        attendance = auditIndex
                    }
                })

                if (attendance) {
                    if (returnOnlyPath) return attendancePath

                    return attendance
                }

                return null
            },
        },
    })
}
